// steps/AssinaturaStepConfirmacao.tsx
import React from 'react';
import type { Plano } from '../planoTypes';
import { AssinaturaFormData } from './PlanoAssinaturaForm';
import PhoneNumber from '../../../../components/inputs/PhoneNumber';
import { ClienteErrors } from './assinaturaCliente.validation';
import { SettingsRow, SettingsSection } from '../../../configuracoes/estabelecimento/Form/SettingsGroup';

interface Props {
    form: AssinaturaFormData;
    plano: Plano;
    onChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    ) => void;
    errors?: ClienteErrors;
}

const AssinaturaStepConfirmacao: React.FC<Props> = ({
                                                    form,
                                                    plano,
                                                    onChange,
                                                    errors,
                                                }) => {
    const isSingleLike =
        plano.billingType === 'UNICO' || plano.periodicity === 'single';
    const termsLabel = isSingleLike
        ? 'Declaro que li e concordo com os termos de uso e com a contratação deste plano.'
        : 'Declaro que li e concordo com os termos de uso e com a recorrência deste plano.';
    const confirmHint = isSingleLike
        ? 'Ao confirmar, a assinatura será registrada e ficará ativa até a validade do plano.'
        : 'Ao confirmar, a assinatura será registrada e ficará ativa conforme a recorrência definida neste plano.';

    const handlePhoneChange = (value: string) => {
        onChange({
            target: {
                name: 'customerPhone',
                value,
                type: 'text',
            },
        } as any);
    };

    return (
        <>
            <SettingsSection title="Seus dados">
                <SettingsRow
                    label="E-mail"
                    htmlFor="customerEmail"
                    description={errors?.customerEmail && <span className="text-error">{errors.customerEmail}</span>}
                >
                    <input
                        id="customerEmail"
                        type="email"
                        name="customerEmail"
                        className="input estab-field"
                        placeholder="voce@email.com"
                        autoComplete="email"
                        value={form.customerEmail}
                        onChange={onChange}
                    />
                </SettingsRow>
                <SettingsRow
                    label="WhatsApp"
                    htmlFor="phone"
                    description={errors?.customerPhone && <span className="text-error">{errors.customerPhone}</span>}
                >
                    <PhoneNumber
                        value={form.customerPhone}
                        setValue={handlePhoneChange}
                        label="Telefone / WhatsApp"
                        hideLabel
                        placeholder="+55 (00) 0 0000-0000"
                        inputClassName="input estab-field"
                    />
                </SettingsRow>
            </SettingsSection>

            <SettingsSection footer={confirmHint}>
                <label className="pla-terms">
                    <input
                        type="checkbox"
                        name="acceptTerms"
                        className="toggle toggle-success shrink-0"
                        checked={form.acceptTerms}
                        onChange={onChange}
                    />
                    <span>{termsLabel}</span>
                </label>
            </SettingsSection>
        </>
    );
};

export default AssinaturaStepConfirmacao;
